/**
 * Shared Image cache for minimap thumbnails. Loads once per src; callers
 * subscribe to know when a previously-loading image becomes ready to paint.
 */

const cache = new Map(); // src -> { img: HTMLImageElement, status: 'loading'|'ready'|'error' }
const waiters = new Set(); // () => void

const notify = () => {
  waiters.forEach((fn) => {
    try {
      fn();
    } catch {
      /* ignore */
    }
  });
};

/** @param {() => void} fn @returns {() => void} unsubscribe */
export const subscribeMinimapImages = (fn) => {
  waiters.add(fn);
  return () => waiters.delete(fn);
};

/**
 * @param {string|null|undefined} src
 * @returns {HTMLImageElement|null} ready image, or null if still loading / failed
 */
export const getMinimapImage = (src) => {
  if (!src) return null;
  let entry = cache.get(src);
  if (!entry) {
    const img = new Image();
    entry = { img, status: 'loading' };
    cache.set(src, entry);
    img.onload = () => {
      entry.status = 'ready';
      notify();
    };
    img.onerror = () => {
      entry.status = 'error';
      notify();
    };
    img.src = src;
  }
  return entry.status === 'ready' ? entry.img : null;
};
